import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface MyProfileState {
  loading: boolean;
  addressDetails: any | null;
  emailAddressDetails: any | null;
  phoneDetails: any | null;
  languageDeatils: any | null;
  error: string | null;
}

const initialState: MyProfileState = {
  loading: false,
  addressDetails: null,
  emailAddressDetails: null,
  phoneDetails: null,
  languageDeatils: null,
  error: null,
};

const myProfileSlice = createSlice({
  name: 'myProfile',
  initialState,
  reducers: {
    myProfileStatesRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    myProfieStatesFetched(state, action: PayloadAction<any>) {
      state.loading = false;
      state.addressDetails = action.payload;
      state.error = null;
    },
    myProfieStatesFetchFailed(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    updateAddressRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    updateAddressSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.addressDetails = { ...state.addressDetails, ...action.payload };
      state.error = null;
    },
    updateAddressFailed(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = action.payload;
    },
    emailAddressDetailsRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    emailAddressDetailsFetched(state, action: PayloadAction<any>) {
      state.loading = false;
      state.emailAddressDetails = action.payload;
      state.error = null;
    },
    emailAddressDetailsFetchFailed(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = action.payload;
    },
    updateEmailAddressRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    updateEmailAddressSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.emailAddressDetails = {
        ...state.emailAddressDetails,
        ...action.payload,
      };
      state.error = null;
    },
    updateEmailAddressFailed(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = action.payload;
    },
    phoneDetailsRequest(
      state,
      action: PayloadAction<{
        accountId: string;
        customerId: string;
      }>
    ) {
      state.loading = true;
      state.error = null;
    },
    phoneDetailsFetched(state, action: PayloadAction<any>) {
      state.loading = false;
      state.phoneDetails = action.payload;
      state.error = null;
    },
    phoneDetailsFetchFailed(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = action.payload;
    },
    updatePhoneRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    updatePhoneSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.phoneDetails = { ...state.phoneDetails, ...action.payload };
      state.error = null;
    },
    updatePhoneFailed(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = action.payload;
    },
    updateLanguageRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    updateLanguageSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.languageDeatils = action.payload;
      state.error = null;
    },
    updateLanguageFailed(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = action.payload;
    },
    resetMyProfileSlice() {
      return initialState; // Reset the slice to its initial state
    },
  },
});

export const {
  myProfileStatesRequest,
  myProfieStatesFetched,
  myProfieStatesFetchFailed,
  updateAddressRequest,
  updateAddressSuccess,
  updateAddressFailed,
  emailAddressDetailsRequest,
  emailAddressDetailsFetched,
  emailAddressDetailsFetchFailed,
  updateEmailAddressRequest,
  updateEmailAddressSuccess,
  updateEmailAddressFailed,
  phoneDetailsRequest,
  phoneDetailsFetched,
  phoneDetailsFetchFailed,
  updatePhoneRequest,
  updatePhoneSuccess,
  updatePhoneFailed,
  updateLanguageRequest,
  updateLanguageSuccess,
  updateLanguageFailed,
  resetMyProfileSlice,
} = myProfileSlice.actions;

export default myProfileSlice.reducer;
